import { Distributor } from '@larvitu/shared/react/components/feature-distributor';
import {ChangeEvent, cloneElement, forwardRef } from 'react';

import type { CheckboxFieldProps } from '@larvitu/shared/mui/ui-form';
import type { DistributorProps } from '@larvitu/shared/react/components/feature-distributor';
import type { FC } from 'react';
import type { ControllerProps, ControllerRenderProps, FieldValues } from 'react-hook-form';

export interface CheckboxFieldAdapterProps
  extends
    Partial<Omit<Parameters<ControllerProps['render']>[0], 'children'>>,
    Partial<Omit<CheckboxFieldProps, 'children'>>
{
  children: React.ReactElement<CheckboxFieldProps & React.ForwardedRef<HTMLButtonElement>>;
  isExposingTextField?: boolean;
}

// export const CheckboxFieldAdapter: FC<CheckboxFieldAdapterProps> = forwardRef(
//   function CheckboxFieldAdapter({
//     children: child,
//     field,
//     fieldState,
//     formState,
//     isExposingTextField = true,
//     helperText = isExposingTextField && ' ',
//     ...props
//   }, ref) {
//     return (
//       <>
//         {cloneElement<CheckboxFieldAdapterProps>( child, {
//           error: Boolean( fieldState?.error ),
//           ref,
//           checked: (field?.value as ControllerRenderProps<FieldValues, string> | undefined)
//             ?? false,
//           helperText: fieldState?.error?.message ?? helperText,
//           ...field,
//           ...props,
//         } )}
//       </>
//     );
//   }
// );

export interface CheckboxFieldAdapterProps
  extends
    Partial<Omit<Parameters<ControllerProps['render']>[0], 'children'>>,
    Partial<Omit<CheckboxFieldProps, 'children'>>
{
  children: DistributorProps<
    & Partial<Omit<CheckboxFieldProps, 'children'>>
    & Partial<Omit<Parameters<ControllerProps['render']>[0], 'children'>>
    & ControllerRenderProps
  >['children'];

  isExposingTextField?: boolean;
}

export const CheckboxFieldAdapter: FC<CheckboxFieldAdapterProps> = forwardRef(
  function CheckboxFieldAdapter({
    children: child,
    field,
    fieldState,
    formState,
    isExposingTextField = true,
    helperText = isExposingTextField && ' ',
    ...props
  }, ref) {
    const { onChange, ...restField } = field!;
    const { onChange: onChangeProps, ...restProps } = props;
    const checked = (field?.value as ControllerRenderProps<FieldValues, string> | undefined)
      ?? false;
    return (
      <Distributor
        error={Boolean( fieldState?.error )}
        ref={ref}
        checked={checked}
        helperText={fieldState?.error?.message ?? helperText}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          onChange( e );
          onChangeProps?.( e, checked );
        }}
        {...restField}
        {...restProps}
      >
        {child}
      </Distributor>
    );
  }
);
